import { removeCharacters } from "@/lib/custom-validations"
import type { IContract, ContractStatus, ICreateContract } from "@/interfaces/contracts.interface"
import { RegisterUsers } from "@/types/users"
import type { MembroEquipe, TeamTabType } from "../types"
import { ITEMS_PER_PAGE } from "../constants/gestao-equipe.constants"
import { AdicionarMembroFormData } from "../components/form/schemas"

export function mapContractStatus(status: ContractStatus): "Ativo" | "Inativo" {
  return status === "ACTIVE" || status === "SIGNED" ? "Ativo" : "Inativo"
}

export function transformContractToMembro(contract: IContract): MembroEquipe {
  return {
    id: contract.id,
    name: contract.staffUser?.person?.name || "N/A",
    phone: contract.staffUser?.person?.cellphone_number || "N/A",
    email: contract.staffUser?.login || "N/A",
    role: contract.staffUser?.person?.role || "N/A",
    status: mapContractStatus(contract.contractStatus),
    date: new Date(contract.createdAt).toLocaleDateString("pt-BR"),
  }
}

export function getInitials(name: string): string {
  return name
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .slice(0, 2)
}

export function filterMembros(
  membros: MembroEquipe[],
  activeTab: TeamTabType,
  searchTerm: string,
  selectedStatuses: string[],
  selectedRoles: string[]
): MembroEquipe[] {
  return membros.filter((membro) => {
    const matchesTab =
      activeTab === "todos" ||
      (activeTab === "ativos" && membro.status === "Ativo") ||
      (activeTab === "inativos" && membro.status === "Inativo")

    const normalizedSearch = searchTerm.trim().toLowerCase()
    const matchesSearch =
      normalizedSearch === "" ||
      membro.name.toLowerCase().includes(normalizedSearch) ||
      membro.email.toLowerCase().includes(normalizedSearch) ||
      membro.phone.includes(searchTerm.trim()) ||
      membro.role.toLowerCase().includes(normalizedSearch)

    const matchesStatus =
      selectedStatuses.length === 0 || selectedStatuses.includes(membro.status)

    const matchesRole =
      selectedRoles.length === 0 || selectedRoles.includes(membro.role)

    return matchesTab && matchesSearch && matchesStatus && matchesRole
  })
}

export function paginateMembros(
  membros: MembroEquipe[],
  currentPage: number
): { paginated: MembroEquipe[]; totalPages: number; startIndex: number; endIndex: number } {
  const totalPages = Math.ceil(membros.length / ITEMS_PER_PAGE)
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE
  const endIndex = startIndex + ITEMS_PER_PAGE
  return {
    paginated: membros.slice(startIndex, endIndex),
    totalPages,
    startIndex,
    endIndex,
  }
}

export function mapAdicionarMembroFormToPayload(projetoId: number, data: AdicionarMembroFormData): ICreateContract {
  return {
    name: data.name,
    email: data.email,
    document: removeCharacters(data.document),
    role: data.role,
    movieId: projetoId,
    pj_name: data.pj_name,
    pj_document: removeCharacters(data.pj_document),
    contract_description: "",
    contract_till: new Date().toISOString(),
    total_amount: 0,
    month_amount: 0
  }
}
